import React from 'react';
import PropTypes from "prop-types";

const BulkPromoNumberLabel = ({ count }) => (
  <p>You have selected {count} Promo Numbers that can be moved</p>
);

BulkPromoNumberLabel.propTypes = {
  count: PropTypes.number.isRequired
};

export default BulkPromoNumberLabel;
